import React from 'react'
import { FormattedMessage } from 'react-intl';
import SearchTable from './SearchTable';
import { drawSupply, compareStrings } from '../utils/utils';
import '../App.css';

const TasksReport = (props) => {  
    
    const layout = {
        bordered : true,
        showSizeChanger : true, 
        pagination : {pageSize: 50, showSizeChanger: false},
        size: "small",
        rowKey : record => record.id,
    };

    const tasks = calcProgress(props.tasks);

    function calcProgress(data) {
        if (!(data instanceof Array)) {
            return [];
        }       
        
        return data.map(rec =>  {
            if (rec.totalProgress && rec.currentProgress)
            {
                rec.progress = (rec.currentProgress / rec.totalProgress) * 100;
            }
            else
            {
                rec.progress = 100;
            }

            return rec;
        });
    }

    const columns = [
        {
            title: <FormattedMessage id="Server"/>,
            dataIndex: 'serverName',
            
            width:250,
            sorter: {
                compare: (a, b) => compareStrings(a.serverName, b.serverName)
            },
            search: true,  
        },
        {
            title: <FormattedMessage id="DeviceMetersTable.name"/>,
            dataIndex: 'name',
            
            sorter: {
                compare: (a, b) => compareStrings(a.name, b.name)
            },
            search: true,  
        },
        {
            title: <FormattedMessage id="Progress"/>,
            dataIndex: 'name',
            
            sorter: {
                compare: (a, b) => compareStrings(a.name, b.name)
            },
            render: (_, record) => {
                return(drawSupply({level: record.progress, maxCapacity: 100, color: "lawngreen"}));
              }   
        },
        {
            title: <FormattedMessage id="Start"/>,
            dataIndex: 'started',
            
            width:150,               
            sorter: {
              compare: (a, b) => 
              {
                  const time_a = Date.parse(a.started);
                  const time_b = Date.parse(b.started);
                  return time_a - time_b;
              }
            },
            search: true,
            render: (_, record) =>
            <div>
                {record.started !== undefined && new Date(record.started).toLocaleString(navigator.language || navigator.userLanguage)}
            </div> 
        },
        {
            title: <FormattedMessage id="End"/>,
            dataIndex: 'finished',
            
            width:150,               
            sorter: {
              compare: (a, b) => 
              {
                  const time_a = Date.parse(a.finished);
                  const time_b = Date.parse(b.finished);
                  return time_a - time_b;
              }
            },
            search: true,
            render: (_, record) =>
            <div>
                {record.finished !== undefined && new Date(record.finished).toLocaleString(navigator.language || navigator.userLanguage)}
            </div> 
        },
        {
            title: <FormattedMessage id="SuppliesTable.status"/>,
            dataIndex: 'status',
            
            sorter: {
                compare: (a, b) => compareStrings(a.status, b.status)
            },
            search: true,  
        },
    ];

    return (
         <div className = "report-table">
            <SearchTable
                layout = {layout}
                type = {undefined}
                columns={columns} 
                dataSource={tasks} 
            />
        </div>
        );   
    
}
  
export default TasksReport;